'use strict';

function Guided () {
	this.current = 0;
	this.skips = {};

	$(this.setup.bind(this));
};

Guided.prototype.setup = function () {
	this.setupNexts();

	this.restore();
};

Guided.prototype.setupNexts = function () {
	$('[data-tutorial-next]').off('click.guided').on('click.guided', this.next.bind(this));
};

Guided.prototype.identifier = function () {
	return 'tutorial' + window.location.pathname.replace('/', '-');
};

Guided.prototype.save = function (to) {
	const id = this.identifier();
	window.localStorage.setItem(id, to || this.current);
};

Guided.prototype.restore = function () {
	const id = this.identifier();
	const saved = window.localStorage.getItem(id);

	console.log('saved', saved);

	if (saved) {
		this.current = saved;
		window.localStorage.removeItem(id);
		this.$current = $('[data-tutorial-step="' + this.current + '"]');
		this.activate();
	}
}

Guided.prototype.start = function () {
	this.current = 0;
	this.next();
};

Guided.prototype.next = function () {
	this.deactivate();

	let $step;
	let skip;

	do {
		this.current += 1;

		$step = $('[data-tutorial-step="' + this.current + '"]');
		skip = this.skips[$step.data('tutorial-skip')];
	} while (skip && skip());

	this.$current = $step;

	this.activate();
};

Guided.prototype.activate = function () {

	console.log(this.$current);

	const $step = this.$current;
	
	if ($step.hasClass('modal')) {
		$step.modal();
	}

	if ($step.data('copy-to')) {
		const targetId = $step.data('copy-to');
		const $target = $(document.getElementById(targetId));

		if (!$target) {
			console.error(`Could not find copy target ${targetId} for step`, $step);
		}

		const $copy = $step.clone();

		$copy.removeAttr('copy-to');
		$copy.data('copied', true);

		$target.prepend($copy);

		$copy.show();
		
		$('html, body').animate({
			scrollTop: $copy.offset().top - window.innerHeight / 2,
		});

		this.setupNexts(); // Need to refresh data-tutorial-next listeners

		this.$aux = $copy;
	}

	if ($step.hasClass('tutorial-popover')) {
		const $target = $(document.getElementById($step.data('target')));
		const content = $step.html();
		
		$target.popover({
			title: 'Guided Tutorial',
			content,
			html: true, // Content is not user-generated, safe from XSS
			placement: 'auto',
			trigger: 'manual',
		});

		$('html, body').animate({
			scrollTop: $target.offset().top - window.innerHeight / 2,
		});

		$target.on('inserted.bs.popover', () => {
			const $tip = $($target.data('bs.popover').tip); // Not ideal, but can't find a better way
			$tip.css('z-index', 1000); // Make sure it doesn't cover modal

			this.setupNexts(); // Need to refresh data-tutorial-next listeners
		});

		$target.popover('show');

		this.$aux = $target;
	}

	if ($step.data('tutorial-save')) {
		this.save(Number($step.data('tutorial-save')));
	}
};

Guided.prototype.deactivate = function () {
	if (!this.$current) { return; }

	const $step = this.$current;

	if ($step.hasClass('modal')) {
		$step.modal('hide');
	}

	if ($step.data('copy-to')) {
		this.$aux.remove();
		this.$aux = null;
	}

	if ($step.hasClass('tutorial-popover')) {
		this.$aux.popover('dispose');
		this.$aux = null;
	}
};

Guided.prototype.addSkip = function (id, skip) {
	this.skips[id] = skip;
};

Guided.prototype.completeStep = function (id) {
	if (this.$current && this.$current.data('tutorial-complete') == id) {
		this.next();
	}
};

module.exports = Guided;
